import React from "react";
import { Container, Row } from "react-bootstrap";

const BlogPostRecommendations = ({ slice }) => {
  return (
    <Container className="simple-section max-container d-none">
      <Row className="w-100 justify-content-center">
        <h1>TEST</h1>
      </Row>
    </Container>
  );
};

export default BlogPostRecommendations;
